import SvgIcon from "@material-ui/core/SvgIcon";

export const CustomPlFlagIcon = (props) => {
    return (
        <SvgIcon width="25" height="16" viewBox="0 0 25 16" fill="none" {...props}>
            <g clip-path="url(#clip0_1589_32821)">
                <path d="M24.2432 0H0.243164V15.9996H24.2432V0Z" fill="#758089"/>
                <path d="M24.2432 0H0.243164V7.99982H24.2432V0Z" fill="#F0F0F0"/>
                <path d="M24.2432 8H0.243164V15.9998H24.2432V8Z" fill="#D80027"/>
            </g>
            <defs>
                <clipPath id="clip0_1589_32821">
                    <rect x="0.243164" width="24" height="15.9998" rx="2" fill="white"/>
                </clipPath>
            </defs>
        </SvgIcon>
    )
}
